// extracted by mini-css-extract-plugin
module.exports = {"annal":"Video_annal__27CAc","text":"Video_text__3HjDc","fjdsioj2":"Video_fjdsioj2__4i3B6","content":"Video_content__1cM5h"};